// Sentry must initialise before anything else renders (side-effect import).
import "./instrument.ts";
// Global stylesheets, imported from the client entry (not a route module) so
// React Router's dev critical-CSS collection doesn't choke on the SCSS partials.
import "./global-styles.ts";
import { StrictMode, startTransition } from "react";
import { hydrateRoot } from "react-dom/client";
import { HydratedRouter } from "react-router/dom";

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>
  );
});
